// extracted by mini-css-extract-plugin
export default {"wrap":"AbsenceComment_wrap__cqfHp","absence__top":"AbsenceComment_absence__top__c6CyX"};